(() => {
  const reviewSelector = '.review_text, .name';

  const applyDirection = (root) => {
    root.querySelectorAll(reviewSelector).forEach((element) => {
      element.setAttribute('dir', 'auto');
    });
  };

  const observeReviews = (root) => {
    if (root.dataset.toraDirectionReady === 'true') return;

    root.dataset.toraDirectionReady = 'true';
    applyDirection(root);

    const observer = new MutationObserver(() => applyDirection(root));
    observer.observe(root, { childList: true, subtree: true });
  };

  const initialize = () => {
    document.querySelectorAll('.loox-reviews-default').forEach(observeReviews);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
